import { NO_REFERENCE_SENTINEL } from "@utils/catalogSubscriptions"
import replaceSlugs from "@utils/replaceSlugs"

import { Table, TopBar } from "@organisms/index"

import { AppFrame } from "@templates/index"

import { useCategoriesQuery } from "@pages/Catalogs/BrandItems/BrandItems.store"
import SubscribeScopeButton from "@pages/Catalogs/BrandItems/components/SubscribeScopeButton/SubscribeScopeButton"
import BrandItemsTableView from "@pages/Catalogs/BrandItems/views/BrandItemsTableView/BrandItemsTableView"

import { CATALOG_ROUTES } from "@routes/catalogs"

import {
    CATALOG_BRAND_ITEMS_LIST_CONTROLS_ACTIVE_TAB,
    CATALOG_BRAND_ITEMS_LIST_CONTROLS_KEYWORD_SEARCH,
    CATALOG_BRAND_ITEMS_LIST_CONTROLS_ORDERING,
    CATALOG_BRAND_ITEMS_LIST_CONTROLS_PHASE,
} from "@constants/storage"

const DEFAULT_TABLE_CONFIG = {
    columnOrder: ["thumbnail_url", "name", "sku", "categories", "list_price", "customer_price", "id"],
    columnVisibility: {},
    columnPinning: {
        left: ["thumbnail_url", "name"],
    },
    sorting: [
        {
            id: "name",
            desc: false,
        },
    ],
}

function BrandItemsContent() {
    const windowData = window as unknown as Record<string, string | undefined>
    const catalogId = windowData.CATALOG_ID ?? ""
    const brandId = windowData.BRAND_ID ?? ""
    const brandName = windowData.BRAND_NAME ?? "Brand"

    // The brandless "No Brand" page carries no brand id, so it addresses the bucket by the null-scope sentinel.
    const brandParam = brandId || String(NO_REFERENCE_SENTINEL)

    const categoriesQuery = useCategoriesQuery(catalogId, brandParam)
    const categories = categoriesQuery.data ?? []

    const storageSlugValues = { brand: brandId || `catalog-${catalogId}-no-brand` }

    return (
        <Table.Provider
            activePhaseStorageKey={replaceSlugs(CATALOG_BRAND_ITEMS_LIST_CONTROLS_PHASE, storageSlugValues)}
            activeTabStorageKey={replaceSlugs(CATALOG_BRAND_ITEMS_LIST_CONTROLS_ACTIVE_TAB, storageSlugValues)}
            searchKeywordsStorageKey={replaceSlugs(
                CATALOG_BRAND_ITEMS_LIST_CONTROLS_KEYWORD_SEARCH,
                storageSlugValues,
            )}
            orderingStorageKey={replaceSlugs(CATALOG_BRAND_ITEMS_LIST_CONTROLS_ORDERING, storageSlugValues)}
            listTitle="Catalog Items"
            objectType="catalog_item"
            objectCreateRoute=""
            objectIndexName="CatalogItem"
            objectName="Catalog Item"
            defaultActivePhase="active"
            isRowClickable={true}
            isEmptyStateCreateButtonVisible={false}
            defaultTableConfigOverride={DEFAULT_TABLE_CONFIG}
        >
            <TopBar.Root>
                <TopBar.Header>
                    <TopBar.TopBarHeaderStart>
                        <TopBar.PageInnerTitle label={brandName} backDestination={CATALOG_ROUTES.LIST} />
                    </TopBar.TopBarHeaderStart>
                    <TopBar.TopBarHeaderEnd>
                        <SubscribeScopeButton
                            catalogId={catalogId}
                            brandId={brandId}
                            brandName={brandName}
                            categories={categories}
                        />
                    </TopBar.TopBarHeaderEnd>
                </TopBar.Header>
            </TopBar.Root>
            <BrandItemsTableView catalogId={catalogId} brandParam={brandParam} categories={categories} />
        </Table.Provider>
    )
}

export default function BrandItems() {
    return (
        <AppFrame.Root navigationType="settings">
            <BrandItemsContent />
        </AppFrame.Root>
    )
}
